import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {NavLink} from 'react-router-dom';

export const Tab = styled(NavLink)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textDecoration: 'none',
  width: 65,
  height: 65,
  padding: 6,
  color: colors.caramel,
  borderRadius: 18,
  backgroundColor: colors.greyLight,
  transition: 'all 0.3s',
  transitionDelay: '0.2s',
  '&.active': {
    color: colors.darkBrown,
    backgroundColor: colors.white,
  },
  '& *': {
    transition: 'all 0.3s',
  },
});

export const Container = styled('div')({
  position: 'fixed',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  bottom: 0,
  left: 0,
  // La barre s'étend sous l'indicateur d'accueil de l'iPhone, onglets au-dessus.
  height: 'calc(76px + env(safe-area-inset-bottom))',
  paddingBottom: 'env(safe-area-inset-bottom)',
  width: '100vw',
  boxShadow: '0 -3px 8px rgba(56,40,24,0.15)',
  backgroundColor: colors.greyLight,
});

// Réserve sous les pages la hauteur ajoutée à la barre, pour que le bas du contenu
// ne passe pas dessous.
export const SafeAreaSpacer = styled('div')({
  height: 'env(safe-area-inset-bottom)',
  backgroundColor: colors.greyLight,
});

export const TabName = styled('div')({
  position: 'absolute',
  bottom: 10,
  transform: 'translateX(-50%)',
  left: '50%',
  fontSize: 12,
  letterSpacing: 0.1,
});
